module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/Block1-0f5b2c71e7ce9fbe3884e5bbdcaa44a3.png";